
import { Component, Prop, Vue } from "vue-property-decorator";

import UploaderState from "@/components/NewFileUploader/NbNewUploader/UploaderState.vue";
import UploaderReuploadButton from "@/components/NewFileUploader/NbNewUploader/UploaderReuploadButton.vue";

import IMAGE from "@/assets/images/upload-error-alt.svg";

const IMAGE_PROPS = {
  width: 32,
  height: 32,
};

const BUTTON_PROPS = {
  outline: true,
  long: true,
  small: true,
};

const MESSAGES = {
  title: "This file format isn't recognised. Please upload only PDF files.",
};

@Component({
  components: {
    UploaderReuploadButton,
    UploaderState,
  },
})
export default class FileLimitUploaderState extends Vue {
  @Prop() readonly file?;

  IMAGE = IMAGE;
  IMAGE_PROPS = IMAGE_PROPS;
  MESSAGES = MESSAGES;
  BUTTON_PROPS = BUTTON_PROPS;

  openFileSelect() {
    const target = this.$refs.file as HTMLInputElement;

    if (!target) return;

    target?.click();
  }

  reUpload(payload) {
    const target = payload.target as HTMLInputElement;

    const targetFile = target?.files?.[0];

    this.$emit("re-upload", targetFile);
  }
}
